export default "__VITE_ASSET__DDbFCiOM__"